import React, { FunctionComponent } from 'react';

import { Attachment } from '@api/v4/attachments/attachmentTypes';
import PDFViewer from '@components/asset/modal/tabs/asset_details/pdfViewer';

export const PDFPreview: FunctionComponent<Attachment> = ({ cdn_url: cdnUrl, url }) => (
  <PDFViewer backupUrl={url} fileUrl={cdnUrl} />
);
